export default "/images/e487309238da92076c1b2c395740e340.avif";